import SvgClose from '@img/icons/close.svg';
import SvgCloseMEP from '@img/icons/close-mep.svg';
import { FocusRing } from '@react-aria/focus';
import * as React from 'react';
import { useModal } from '../Context/Context';
import S from './Close.styles';
const Close = ({ site }) => {
    const modal = useModal();
    return (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
        React.createElement(S.Button, { type: "button", "aria-label": "Close", onClick: (event) => {
                event.preventDefault();
                if (modal.showClose && modal.onClose) {
                    modal.onClose();
                }
            } }, site === 'ess' ? React.createElement(SvgClose, null) : React.createElement(SvgCloseMEP, null))));
};
export default Close;
